import React from 'react';

const Trash = ({ color }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='19'
      height='19'
      viewBox='0 0 16 20'
    >
      <path
        fill={color}
        d='M5.485 20a3 3 0 0 1-2.978-2.635L1.115 6H1a1 1 0 0 1-.116-1.993L1 4h3a4 4 0 0 1 8 0h3a1 1 0 0 1 .116 1.993L15 6h-.116l-1.39 11.365A3 3 0 0 1 10.516 20zm-.993-2.879a1 1 0 0 0 .878.872l.115.007h5.031a1 1 0 0 0 .993-.879L12.87 6H3.13zM10 4a2 2 0 0 0-4 0z'
      />
    </svg>
  );
};

export default Trash;
